import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext, useReducer } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationFlag from '@wix/da-ds/pkg/Indicators/DeviationFlag';
import DeviationFlagCard from './_partials/DeviationFlagCard';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import { isHyped } from '../../../DeviationViews/_helpers';
import s from './DeviationFlags.scss';
const createFlagStateReducer = (isMobile)=>(state, action)=>{
        const { variant, gesture } = action;
        let visibleFlag;
        let hoverFlag;
        switch(variant){
            case 'daily-deviation':
                visibleFlag = 'isDdListVisible';
                hoverFlag = 'isDdHovering';
                break;
            case 'hype':
                visibleFlag = 'isHypeListVisible';
                hoverFlag = 'isHypeHovering';
                break;
            default:
                return state;
        }
        switch(gesture){
            case 'mouseEnter':
                return isMobile ? state : {
                    [visibleFlag]: true,
                    [hoverFlag]: true
                };
            case 'mouseLeave':
                return isMobile ? state : _object_spread_props(_object_spread({}, state), {
                    [hoverFlag]: false
                });
            case 'click':
                return isMobile ? state[visibleFlag] ? _object_spread_props(_object_spread({}, state), {
                    [hoverFlag]: false
                }) : {
                    [visibleFlag]: true,
                    [hoverFlag]: true
                } : state;
            case 'transitionEnd':
                return state[hoverFlag] ? state : _object_spread_props(_object_spread({}, state), {
                    [visibleFlag]: false
                });
            case 'close':
                return _object_spread_props(_object_spread({}, state), {
                    [hoverFlag]: false
                });
            default:
                return state;
        }
    };
const DeviationFlags = ({ deviation, deviation: { dailyDeviation }, alwaysExpanded, disableLabel, className })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const [{ isDdListVisible, isDdHovering, isHypeListVisible, isHypeHovering }, dispatch] = useReducer(createFlagStateReducer(isMobile), {
        isDdListVisible: false,
        isDdHovering: false,
        isHypeListVisible: false,
        isHypeHovering: false
    });
    const hyped = isHyped(deviation);
    if (!dailyDeviation && !hyped) {
        return null;
    }
    const bothFlags = dailyDeviation && hyped;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s['root-updated'], bothFlags && s['both-flags'])
    }, dailyDeviation && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['flag-root'], alwaysExpanded && s['always-expanded'], isDdHovering && s['hovering'], disableLabel && s['disable-label'], className),
        onClick: ()=>dispatch({
                variant: 'daily-deviation',
                gesture: 'click'
            }),
        onMouseEnter: ()=>dispatch({
                variant: 'daily-deviation',
                gesture: 'mouseEnter'
            }),
        onMouseLeave: ()=>dispatch({
                variant: 'daily-deviation',
                gesture: 'mouseLeave'
            }),
        onTransitionEnd: (e)=>{
            if (e.propertyName === 'opacity') {
                dispatch({
                    variant: 'daily-deviation',
                    gesture: 'transitionEnd'
                });
            }
        }
    }, /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        placement: "top",
        secondaryPlacement: isMobile ? 'end' : 'start',
        wrapperClassName: s['tooltip'],
        usePortal: false,
        eventsEnabled: isDdHovering,
        onClickOutside: ()=>dispatch({
                variant: 'daily-deviation',
                gesture: 'close'
            }),
        popoverContent: ({ placement })=>/*#__PURE__*/ React.createElement("div", {
                className: classnames(s['flag-list'], s[placement], isDdListVisible && s['flag-list-visible'])
            }, /*#__PURE__*/ React.createElement(DeviationFlagCard, {
                variant: "daily-deviation",
                deviation: deviation
            }))
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['base']
    }, /*#__PURE__*/ React.createElement(DeviationFlag, {
        variant: "daily-deviation",
        size: isMobile ? 'medium' : 'large',
        className: s['flag']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['collapsed-title']
    }, t('actionbar.flags.dailyDeviation'))))), hyped && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['flag-root'], alwaysExpanded && s['always-expanded'], isHypeHovering && s['hovering'], disableLabel && s['disable-label'], className),
        onClick: ()=>dispatch({
                variant: 'hype',
                gesture: 'click'
            }),
        onMouseEnter: ()=>dispatch({
                variant: 'hype',
                gesture: 'mouseEnter'
            }),
        onMouseLeave: ()=>dispatch({
                variant: 'hype',
                gesture: 'mouseLeave'
            }),
        onTransitionEnd: (e)=>{
            if (e.propertyName === 'opacity') {
                dispatch({
                    variant: 'hype',
                    gesture: 'transitionEnd'
                });
            }
        }
    }, /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        placement: "top",
        secondaryPlacement: isMobile ? 'end' : 'start',
        wrapperClassName: s['tooltip'],
        usePortal: false,
        eventsEnabled: isHypeHovering,
        onClickOutside: ()=>dispatch({
                variant: 'hype',
                gesture: 'close'
            }),
        popoverContent: ({ placement })=>/*#__PURE__*/ React.createElement("div", {
                className: classnames(s['flag-list'], s[placement], isHypeListVisible && s['flag-list-visible'])
            }, /*#__PURE__*/ React.createElement(DeviationFlagCard, {
                variant: "hype",
                deviation: deviation
            }))
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['base']
    }, /*#__PURE__*/ React.createElement(DeviationFlag, {
        variant: "hype",
        size: isMobile ? 'medium' : 'large',
        className: s['flag']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['collapsed-title']
    }, t('actionbar.flags.hype'))))));
};
DeviationFlags.displayName = 'DeviationFlags';
export default DeviationFlags;
